<template>
  <section v-if="isAdmin" class="target-campaign-health-panel text-left w-100">
    <button
      v-if="showButton"
      type="button"
      class="btn btn-sm situation-tone-cell"
      :class="situationButtonToneClass"
      :disabled="loading"
      title="Target situation"
      aria-label="Target situation"
      @click="loadHealth"
    >
      <i class="icon-search text-dark"></i>
    </button>
    <span
      v-if="showButton && loading"
      class="loadingres ml-2 spinner-border loading-spinner text-primary"
    ></span>
    <div
      v-if="!showButton && loading"
      class="text-center py-3"
    >
      <span class="spinner-border spinner-border-sm text-primary"></span>
      <span class="ml-2 small text-muted">Loading…</span>
    </div>

    <div v-if="error" class="alert alert-danger mt-2 py-2 small mb-0">
      {{ error }}
    </div>

    <TargetCampaignHealthContent
      v-if="health"
      :health="health"
      :target-id="target_id"
      :list-tone="listTone"
      :list-headline="listHeadline"
      :class="showButton ? 'mt-2' : ''"
      @relaunched="loadHealth"
    />
  </section>
</template>

<script>
import { targetsService } from "@/_services";
import { mapState } from "vuex";
import TargetCampaignHealthContent from "@/components/Targets/TargetCampaignHealthContent.vue";

export default {
  name: "TargetCampaignHealthPanel",

  components: {
    TargetCampaignHealthContent,
  },

  props: {
    target_id: {
      type: [Number, String],
      required: true,
    },
    showButton: {
      type: Boolean,
      default: true,
    },
    buttonLabel: {
      type: String,
      default: "Situación",
    },
    autoLoad: {
      type: Boolean,
      default: false,
    },
    listTone: {
      type: String,
      default: "",
    },
    listHeadline: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      health: null,
      loading: false,
      error: null,
    };
  },

  computed: {
    ...mapState({
      user: (state) => state.authentication.user,
    }),
    isAdmin() {
      return this.user && parseInt(this.user.role_id, 10) === 1;
    },
    situationButtonToneClass() {
      const tone =
        (this.health && this.health.plain_language && this.health.plain_language.tone) ||
        "";
      if (tone === "ok") {
        return "situation-tone--ok";
      }
      if (tone === "warning") {
        return "situation-tone--warning";
      }
      if (tone === "danger") {
        return "situation-tone--danger";
      }
      return "situation-tone--loading";
    },
  },

  watch: {
    target_id(newId, oldId) {
      if (newId && newId !== oldId) {
        this.resetState();
        if (this.autoLoad && this.isAdmin) {
          this.loadHealth();
        }
      }
    },
  },

  created() {
    if (this.autoLoad && this.target_id && this.isAdmin) {
      this.loadHealth();
    }
  },

  methods: {
    resetState() {
      this.health = null;
      this.error = null;
      this.loading = false;
    },
    loadHealth() {
      if (!this.target_id || this.loading || !this.isAdmin) {
        return;
      }
      this.loading = true;
      this.error = null;
      this.health = null;
      targetsService
        .getCampaignHealthContactCounts(this.target_id)
        .then((result) => {
          this.health = result;
          const plain = result && result.plain_language;
          this.$emit("health-loaded", {
            target_id: this.target_id,
            tone: (plain && plain.tone) || "warning",
            headline: (plain && plain.headline) || "",
          });
        })
        .catch((err) => {
          this.error =
            (err && err.message) || "Could not load target situation.";
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.situation-tone-cell {
  min-width: 2.25rem;
  min-height: 2.25rem;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
}
.situation-tone--ok {
  background: #e8f5e9;
  border: 1px solid #a5d6a7;
}
.situation-tone--warning {
  background: #fff8e1;
  border: 1px solid #ffe082;
}
.situation-tone--danger {
  background: #ffebee;
  border: 1px solid #ef9a9a;
}
.situation-tone--loading {
  background: #f5f5f5;
  border: 1px solid #e0e0e0;
}
</style>
